import React from "react";
import Box from "@mui/material/Box";
import TabelBarang from "../../components/TabelBarang/TabelBarang";
import ModalImport from "../../components/ModalImport/ModalImport";
import ModalKatalog from "../../components/ModalKatalog/ModalKatalog";
import ModalKategori from "../../components/ModalKategori/ModalKategori";
import TokoTidakAktif from "../../components/TokoTidakAktif/TokoTidakAktif";
import ModalPrintBarcode from "../../components/ModalPrintBarcode/ModalPrintBarcode";
import ModalEditKategori from "../../components/ModalEditKategori/ModalEditKategori";
import ModalDeleteKategori from "../../components/ModalDeleteKategori/ModalDeleteKategori";
import { useAuth } from "../../context/authContext";
import { getLocalWarehouseId } from "../../utils/handleChangeWarehouseId";
import useWarehouse from "../../services/queries/useWarehouse";
import useUser from "../../services/queries/useUser";
import useKategori from "../../services/queries/useKategori";
import moment from "moment";
import "moment/locale/id";
import useTime from "../../services/queries/useTime";

moment.locales();
moment.locale("id");

interface IStokBarangProps {}

const StokBarang = (props: IStokBarangProps) => {
    const { warehouseIdUser } = useAuth();
    const initialParamsKategori = {
        warehouseId: Number(warehouseIdUser && warehouseIdUser[0]),
        size: 500,
        page: 1,
        search: "",
    };
    const { refetch: refetchKategori } = useKategori(initialParamsKategori);

    const initialParamsWarehouse = {
        size: 500,
        page: 1,
        search: "",
    };
    const { data: warehouse } = useWarehouse(initialParamsWarehouse);
    const { data: time } = useTime();
    const { data: user } = useUser();

    const warehouseId = React.useMemo(() => {
        if (user?.userId) {
            return getLocalWarehouseId(user?.userId);
        }
        return null;
    }, [user?.userId]);

    const warehouseData = React.useMemo(() => {
        if (warehouseId) {
            return warehouse?.content.find((li) => li.id === warehouseId);
        }
        return warehouse?.content[0];
    }, [warehouse?.content, warehouseId]);

    // const isSudahJatuhTempo = moment(time?.datetime).isAfter(
    //     warehouseData?.pembayaranBerikutnya,
    // );

    if (user?.aksesStok === 0 || user?.aksesStok === null) {
        return <TokoTidakAktif label="Anda tidak memiliki akses halaman ini" />;
    }

    // if (
    //     warehouseData &&
    //     (warehouseData?.isActive === 0 ||
    //         warehouseData?.isActive === null ||
    //         warehouseData?.lewatTempoPro === 1 ||
    //         isSudahJatuhTempo)
    // ) {
    //     return <TokoTidakAktif namaToko={warehouseData.namaToko} />;
    // }

    return (
        <Box>
            <TabelBarang />
            <ModalKategori refetch={refetchKategori} />
            <ModalDeleteKategori refetch={refetchKategori} />
            <ModalEditKategori refetch={refetchKategori} />
            <ModalKatalog namaWarehouse={warehouseData?.nama} />
            <ModalImport
                namaToko={warehouseData?.nama}
                // isPro={warehouseData?.isPro}
            />
            <ModalPrintBarcode />
        </Box>
    );
};

export default StokBarang;
